import React, { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';

import Dashboard from './tabs/Dashboard';
import CustomerManagement from './tabs/CustomerManagement';
import BuyAndSellGold from './tabs/GoldSilverManagement/BuyAndSellGold';
import Regions from './tabs/BranchManagement/Regions';
import Branches from './tabs/BranchManagement/Branches';
import Settings from './tabs/Settings';
import Admins from './tabs/AdminManagement/Admins';
import InventoryTransactions from './tabs/GoldSilverManagement/InventoryTransactions';
import Roles from './tabs/AdminManagement/Roles';
import Approval from './tabs/Approval';

import NavBar from '~components/molecules/NavBar';
import TabDisplay, { TTabs } from '~components/atoms/TabDisplay';
import Text from '~components/atoms/Text';
import AuthUserProfileCard from '~components/molecules/AuthUserProfileCard';
import UnloadEventInterceptor from '~components/molecules/UnloadEventInterceptor';

import { ModuleEnum, NavigationTabsEnum, PermissionsEnum } from '~utils/enums';

import * as Styles from './_home.module.scss';
import dayjs from 'dayjs';
import { invalidModules } from '~utils/constants';
import SplitSettings from './tabs/ProductManagement/SplitSettings';
import Discount from './tabs/ProductManagement/Discount';
import ProjectManagement from './tabs/ProjectManagement';
import SerialNumberSearch from './tabs/GoldSilverManagement/SerialNumberSearch';
import MarketStatus from './tabs/GoldSilverManagement/MarketStatus';
import GoldInventoryReport from './tabs/GoldSilverManagement/GoldInventoryReport';
import GoldConversion from './tabs/GoldSilverManagement/GoldConversion';
import GoldSilverInventory from './tabs/GoldSilverManagement/GoldSilverInventory';
import StockOut from './tabs/GoldSilverManagement/StockOut';

const Home = () => {
    const currentTab = useAppSelector(state => state.navigation.currentTab);
    const userAccess = useAppSelector(state => state.auth.userDetails.access);
    const { displayName, roleName } = useAppSelector(state => state.auth.userDetails);
    const apiKeySettings = useAppSelector(state => state.setting.apiKeySettings);

    const viewAccessModules = userAccess.find(access => access.permission === PermissionsEnum.View)?.modules || [];

    const dispatch = useAppDispatch();

    const setTab = (tab: NavigationTabsEnum) => dispatch(combinedActions.navigationSetCurrentTab(tab));

    useEffect(() => {
        if (viewAccessModules.length > 0) {
            const massagedViewAccessModules = viewAccessModules.filter(module => !invalidModules.includes(module));

            if (massagedViewAccessModules.includes(ModuleEnum.Dashboard)) {
                setTab(NavigationTabsEnum.Dashboard);
                return;
            }

            if (massagedViewAccessModules.includes(ModuleEnum.CustomerManagement)) {
                setTab(NavigationTabsEnum.CustomerManagement);
                return;
            }

            if (massagedViewAccessModules.includes(ModuleEnum.Product)) {
                setTab(NavigationTabsEnum.SplitSettings);
                return;
            }

            if (massagedViewAccessModules.includes(ModuleEnum.BuySellGold)) {
                setTab(NavigationTabsEnum.GoldManagementBuyAndSellGold);
                return;
            }

            if (massagedViewAccessModules.includes(ModuleEnum.Inventory)) {
                setTab(NavigationTabsEnum.GoldManagementGoldInventory);
                return;
            }

            if (massagedViewAccessModules.includes(ModuleEnum.Inventory)) {
                setTab(NavigationTabsEnum.GoldManagementGoldInventoryReport);
                return;
            }

            if (massagedViewAccessModules.includes(ModuleEnum.InventoryTransaction)) {
                setTab(NavigationTabsEnum.GoldManagementInventoryTransactions);
                return;
            }

            if (massagedViewAccessModules.includes(ModuleEnum.Conversion)) {
                setTab(NavigationTabsEnum.Conversion);
                return;
            }

            if (massagedViewAccessModules.includes(ModuleEnum.InventoryTransaction)) {
                setTab(NavigationTabsEnum.GoldManagementSerialNumberSearch);
                return;
            }

            if (massagedViewAccessModules.includes(ModuleEnum.MarketStatus)) {
                setTab(NavigationTabsEnum.MarketStatus);
                return;
            }

            // if (massagedViewAccessModules.includes(ModuleEnum.Conversion)) {
            //     setTab(NavigationTabsEnum.Conversion);
            //     return;
            // }

            if (massagedViewAccessModules.includes(ModuleEnum.Project)) {
                setTab(NavigationTabsEnum.ProjectManagement);
                return;
            }

            if (massagedViewAccessModules.includes(ModuleEnum.Approval)) {
                setTab(NavigationTabsEnum.Approval);
                return;
            }

            if (massagedViewAccessModules.includes(ModuleEnum.BranchManagement)) {
                setTab(NavigationTabsEnum.BranchManagementRegions);
                return;
            }

            if (massagedViewAccessModules.includes(ModuleEnum.RBAC)) {
                setTab(NavigationTabsEnum.AdminManagementRoles);
                return;
            }

            if (massagedViewAccessModules.includes(ModuleEnum.Discount)) {
                setTab(NavigationTabsEnum.Discount);
                return;
            }

            if (massagedViewAccessModules.includes(ModuleEnum.Setting)) {
                setTab(NavigationTabsEnum.Settings);
                return;
            }
        }
    }, [viewAccessModules]);

    const tabs = [
        viewAccessModules.find(module => module === ModuleEnum.Dashboard) && {
            name: NavigationTabsEnum.Dashboard,
            element: <Dashboard />,
        },
        viewAccessModules.find(module => module === ModuleEnum.CustomerManagement) && {
            name: NavigationTabsEnum.CustomerManagement,
            element: <CustomerManagement />,
        },
        viewAccessModules.find(module => module === ModuleEnum.BuySellGold) && {
            name: NavigationTabsEnum.GoldManagementBuyAndSellGold,
            element: <BuyAndSellGold />,
        },
        viewAccessModules.find(module => module === ModuleEnum.Inventory) && {
            name: NavigationTabsEnum.GoldManagementGoldInventory,
            element: <GoldSilverInventory />,
        }, viewAccessModules.find(module => module === ModuleEnum.Inventory) && {
            name: NavigationTabsEnum.GoldManagementGoldInventoryReport,
            element: <GoldInventoryReport />,
        },
        viewAccessModules.find(module => module === ModuleEnum.InventoryTransaction) && {
            name: NavigationTabsEnum.GoldManagementInventoryTransactions,
            element: <InventoryTransactions />,
        },
        viewAccessModules.find(module => module === ModuleEnum.Conversion) && {
            name: NavigationTabsEnum.Conversion,
            element: <GoldConversion />,
        },
        viewAccessModules.find(module => module === ModuleEnum.InventoryTransaction) && {
            name: NavigationTabsEnum.GoldManagementSerialNumberSearch,
            element: <SerialNumberSearch />,
        },
        viewAccessModules.find(module => module === ModuleEnum.Project) && {
            name: NavigationTabsEnum.ProjectManagement,
            element: <ProjectManagement />,
        },
        // test temporary access using dashboard
        viewAccessModules.find(module => module === ModuleEnum.MarketStatus) && {
            name: NavigationTabsEnum.MarketStatus,
            element: <MarketStatus />,
        },
        {
            name: NavigationTabsEnum.GoldManagementStockOut,
            element: <StockOut />,
        },
        viewAccessModules.find(module => module === ModuleEnum.Approval) && {
            name: NavigationTabsEnum.Approval,
            element: <Approval />,
        },
        viewAccessModules.find(module => module === ModuleEnum.Product) && {
            name: NavigationTabsEnum.SplitSettings,
            element: <SplitSettings />,
        },
        viewAccessModules.find(module => module === ModuleEnum.Discount) && {
            name: NavigationTabsEnum.Discount,
            element: <Discount />,
        },
        viewAccessModules.find(module => module === ModuleEnum.BranchManagement) && {
            name: NavigationTabsEnum.BranchManagementRegions,
            element: <Regions />,
        },
        viewAccessModules.find(module => module === ModuleEnum.BranchManagement) && {
            name: NavigationTabsEnum.BranchManagementBranches,
            element: <Branches />,
        },
        viewAccessModules.find(module => module === ModuleEnum.RBAC) && {
            name: NavigationTabsEnum.AdminManagementRoles,
            element: <Roles />,
        },
        viewAccessModules.find(module => module === ModuleEnum.RBAC) && {
            name: NavigationTabsEnum.AdminManagementAdmins,
            element: <Admins />,
        },
        viewAccessModules.find(module => module === ModuleEnum.Setting) && {
            name: NavigationTabsEnum.Settings,
            element: <Settings />,
        },
    ].filter(item => item);

    const renderExpiryMessage = () => {
        if (apiKeySettings) {
            if (apiKeySettings.expiryDate === null) return null;

            const getNumOfDays = dayjs(apiKeySettings.expiryDate).diff(dayjs(), 'day');

            if (getNumOfDays > 30) return null;

            return (
                <div className={Styles['expiry-text']}>
                    GoldSync API key expiring soon at {dayjs(apiKeySettings?.expiryDate).format('DD MMM YYYY')}
                </div>
            );
        }
        return null;
    };

    return (
        <div className={Styles.container}>
            <NavBar currentTab={currentTab} />

            <div className={Styles.subcontainer}>
                <div className={Styles['page-header-container']}>
                    <Text
                        label={currentTab}
                        className={Styles['page-title']}
                        size='l'
                    />

                    <div className={Styles['right-container']}>
                        {
                            viewAccessModules.find(module => module === ModuleEnum.Dashboard)
                            &&
                            renderExpiryMessage()
                        }

                        <AuthUserProfileCard
                            text1={roleName}
                            text2={displayName}
                        />
                    </div>
                </div>

                <TabDisplay
                    containerStyle={Styles['tab-display']}
                    currentTab={currentTab}
                    tabs={tabs as TTabs[]}
                />
            </div>

            <UnloadEventInterceptor />
        </div>
    );
};

export default Home;
